const pageLinksData = [
  { type: "standalone", innerHTML: "HOME", href: "/" },
  { type: "standalone", innerHTML: "ABOUT", href: "/about" },
  { type: "standalone", innerHTML: "PRICING", href: "/pricing" },
  { type: "standalone", innerHTML: "HELP", href: "http://docs.hypersocio.com/" },
  { type: "standalone", innerHTML: "LOGIN / REGISTER", href: "https://dev.hypersocio.com/login" },
  // { type: "standalone", innerHTML: "TRY FOR FREE", href: "/try" }
];

export default pageLinksData